import { useEffect } from 'react';
import './mobile-scope.css';
import Nav from './components/Nav/Nav.jsx';
import Hero from './components/Hero/Hero.jsx';
import DisconnectedSteps from './components/DisconnectedSteps/DisconnectedSteps.jsx';
import ClosedLoopSection from './components/ClosedLoopSection/ClosedLoopSection.jsx';
import HowItWorks from './components/HowItWorks/HowItWorks.jsx';
import CardsStack from './components/CardsStack/CardsStack.jsx';
import Testimonials from './components/Testimonials/Testimonials.jsx';
import Founders from './components/Founders/Founders.jsx';
import CTASection from './components/CTASection/CTASection.jsx';
import Footer from './components/Footer/Footer.jsx';
import ZohoIQWidget from '../utils/ZohoIQWidget';

// Shared Enquiry Hook and Components
import { useEnquiry } from '../hooks/useEnquiry';
import EnquiryDrawer from '../components/shared/modals/EnquiryDrawer';
import FormModal from '../components/shared/modals/FormModal';
import SchoolAiPage from '../components/SchoolAiPage';

export default function MobilePage() {
  const {
    enquiryOpen,
    setEnquiryOpen,
    openSchoolForm,
    options,
    onOptionSelect,
    handleCloseForm,
    handleEnquiry
  } = useEnquiry();

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const prevHtmlOx = html.style.overflowX;
    const prevBodyOx = body.style.overflowX;
    
    // Maintain overflowX: clip for sticky support as per original working state
    html.style.overflowX = 'clip';
    body.style.overflowX = 'clip';

    return () => {
      html.style.overflowX = prevHtmlOx;
      body.style.overflowX = prevBodyOx;
    };
  }, []);

  return (
    <div className="mobile-outer-wrapper">
      <div className="mobile-inner-scroll website-mobile-scope">
        <Nav handleBtnClick={handleEnquiry} />
        <main>
          <Hero handleBtnClick={handleEnquiry} />
          <DisconnectedSteps />
          <ClosedLoopSection handleBtnClick={handleEnquiry} />
          <HowItWorks handleBtnClick={handleEnquiry} />
          <CardsStack />
          <Testimonials />
          <Founders />
          <CTASection handleBtnClick={handleEnquiry} />
        </main>
        <Footer />

        <ZohoIQWidget />

        {enquiryOpen && (
          <EnquiryDrawer
            options={options}
            setEnquiryOpen={setEnquiryOpen}
            enquiryOpen={enquiryOpen}
            onOptionSelect={onOptionSelect}
          />
        )}

        {openSchoolForm && (
          <FormModal isOpen={openSchoolForm} onRequestClose={handleCloseForm}>
            <SchoolAiPage onClose={handleCloseForm} />
          </FormModal>
        )}
      </div>
    </div>
  );
}
